import {EventEmitter} from "events";

class AuthStore extends EventEmitter {
	constructor() {
		super();
		this.loading = false;
		//
		this.user = {};
		this.date = {};
	}
	setUser (user) {
		this.user = user;
	}
	setDate (date) {
		this.date = date;
	}
}

const authStore = new AuthStore();

export default authStore;


/** WEBPACK FOOTER **
 ** ./src/stores/AuthStore.js
 **/